import { Injectable } from "@angular/core";
import { take } from "rxjs/operators";
import { EventsService } from "src/app/modules/events/events.service";
import { masterApiUrl } from "src/app/modules/events/serviceUrl.constant";
import { AsvType } from "src/app/shared/models/app";
import { CacheResolverService } from "../cache/cache-resolver.service";
import { CacheConstant } from "../cache/cache.constant";

@Injectable({
    providedIn: 'root'
})
export class DataCacheService {

    constructor(
        private cacheService: CacheResolverService,
        private eventsService: EventsService
    ) {

    }

    loadApiCacheEntries() {
        this.loadAsvTypes();
    }

    private loadAsvTypes() {
        if (!this.cacheService.has(CacheConstant.DataCache.Asv)) {
            this.eventsService.getApiRequest("masterdata", masterApiUrl.getAsvTypes)
                .pipe(take(1))
                .subscribe((res: Array<AsvType>) => {
                    this.cacheService.set(CacheConstant.DataCache.Asv, res);
                }, err => {
                    this.cacheService.set(CacheConstant.DataCache.Asv, []);
                });
        }
    }

}